export default "__VITE_ASSET__B_NtSZ6b__"